import styled from "styled-components";
import colors from "../../config/colors";

// position:fixed;
//     top:0px;
//     right:0px;
//     height:100vh;
//     width:300px;
//     pointer-events: none
export const ToastsContainer = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  height: auto;
  width: 300px;
  z-index: 99999;
`;
export const ToastContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 15px 0 0;
  border-radius: 10px;
  background-color: ${(props) =>
    props.type === "inProgress" ? colors.darkBackground : colors[props.type]};
  border: solid 1px ${colors.background}44;
  height: ${(props) => (props.escape ? "fit-content" : "fit-content")};
  transition: all 0.2s;
  overflow: hidden;
  position: relative;
  top: 20px;
  right: 10px;
`;

export const ToastMessage = styled.div`
  color: ${colors.background};
  margin-left: 15px;
  align-items: center;
  display: flex;
  text-transform: capitalize;
  font-size: 15px;
`;
export const IconContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background-color: ${colors.text}44;
  border-radius: 10px;
  box-sizing: border-box;
  cursor: pointer;
  margin-left: ${(props) => (props.iconLeft ? "auto" : "none")};
  margin-right: ${(props) => (props.iconLeft ? "10px" : "none")};
`;

// export const ProgressBar = styled.div`
//   height: 3px;
//   width: 100%;
//   // background: transparent;
//   background: ${(props) =>
//     props.type === "inProgress"
//       ? "none"
//       : props.type === "failure"
//       ? "#ae2424"
//       : "#00b312"};
//   border-radius: 0 0 6px 6px;
//   overflow: hidden;
//   position: relative;
//   margin-top: 15px;

//   &::before {
//     display: ${(props) => (props.type === "inProgress" ? "none" : "block")};
//     content: "";
//     position: absolute;
//     height: 100%;
//     // background: #00b312;
//     background: ${(props) =>
//       props.type === "inProgress"
//         ? "none"
//         : props.type === "failure"
//         ? "#ae2424"
//         : "#00b312"};
//     width: ${(props) => props.percent}%;
//     transition: width 0.2s linear;
//   }
// `;

export const ProgressBar = styled.div`
  height: 3px;
  width: 100%;
  background: transparent;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
  position: relative;
  margin-top: 15px;
`;

export const ProgressFill = styled.div`
  height: 100%;
  width: ${(props) => props.percent}%;
  background: ${(props) =>
    props.type === "inProgress"
      ? "none"
      : props.type === "failure"
      ? "#ae2424"
      : "#00b312"};
  transition: width 0.2s linear;
`;
